var React = require("react");
var PackageCard =             require("./cards/PackageCard.jsx");
var LibraryCard =             require("./cards/LibraryCard.jsx");
var ApplicationContext = require("../config/ApplicationContext.js");
var DisplayAssets =      require("./DisplayAssets.jsx");

class DisplayAssetsHome extends React.Component {

    constructor() {
        super();

        this.getDefaultAssetsConfig = this.getDefaultAssetsConfig.bind(this);
    }


    hasFinishedThumbnail(asset){
         // we need thumb_temporary to be false to know that it has a generated thumbnail.
         // undefined should not resolve here, thus the === (it must be false)
         return asset.thumb_temporary === false
    }

    justReturnTrue(){
         return true;
    }

    getDefaultAssetsConfig(){
        return {
            packages: {
                endpoint: "explore/packages",
                numberOfAssets: 6,
                condition: "properties.height=[1000,100000]",
                displayName: "Packages",
                cssCardTag: "package",
                CardType: PackageCard,
                assetCondition: this.hasFinishedThumbnail,
                defaultAssets: this.getDefaultPackages(),
                linkTo: "/search/packages",
                linkName: "Browse Packages",
            },

            libraries: {
                endpoint: "explore/libraries",
                numberOfAssets: 6,
                condition: "",
                displayName: "Libraries",
                cssCardTag: "library",
                CardType: LibraryCard,
                assetCondition: this.justReturnTrue,
                defaultAssets: [],
                linkTo: "/search/libraries",
                linkName: "Browse Libraries",
            },
            defaultSelected: "packages"
        };
    }

    getDefaultPackages() {
        return [
            {
                cardType:"package",
                id:"822",
                onEdit:this.onEdit,
                name:"DIL16" ,
                user_name:"EAGLE",
                description:"DIL16",
                avatar:ApplicationContext.assetUrlPrefix + "/assets/icons/eagle-avatar.png",
                thumb_URL:ApplicationContext.assetUrlPrefix + "/assets/home/recent/dil16.png",
                thumbnail:ApplicationContext.assetUrlPrefix + "/assets/home/recent/dil16.png",
            },
            {
                cardType:"package",
                id:"23425",
                onEdit:this.onEdit,
                name:"Panasonic E" ,
                user_name:"EAGLE",
                description:"Panasonic E",
                avatar:ApplicationContext.assetUrlPrefix + "/assets/icons/eagle-avatar.png",
                thumb_URL:ApplicationContext.assetUrlPrefix + "/assets/home/recent/panasonic_e.png",
                thumbnail:ApplicationContext.assetUrlPrefix + "/assets/home/recent/panasonic_e.png",
            },
            {
                cardType:"package",
                id:"43389",
                onEdit:this.onEdit,
                name:"SOT23" ,
                user_name:"EAGLE",
                description:"SOT23",
                avatar:ApplicationContext.assetUrlPrefix + "/assets/icons/eagle-avatar.png",
                thumb_URL:ApplicationContext.assetUrlPrefix + "/assets/home/recent/sot23.png",
                thumbnail:ApplicationContext.assetUrlPrefix + "/assets/home/recent/sot23.png",
            },
            {
                cardType:"package",
                id:"29899",
                onEdit:this.onEdit,
                name:"TO-3" ,
                user_name:"EAGLE",
                description:"TO-3",
                avatar:ApplicationContext.assetUrlPrefix + "/assets/icons/eagle-avatar.png",
                thumb_URL:ApplicationContext.assetUrlPrefix + "/assets/home/recent/to-3.png",
                thumbnail:ApplicationContext.assetUrlPrefix + "/assets/home/recent/to-3.png",
            },
            {
                cardType:"package",
                id:"26668",
                onEdit:this.onEdit,
                name:"7SEG-13" ,
                user_name:"EAGLE",
                description:"7SEG-13",
                avatar:ApplicationContext.assetUrlPrefix + "/assets/icons/eagle-avatar.png",
                thumb_URL:ApplicationContext.assetUrlPrefix + "/assets/home/recent/7seg-13.png",
                thumbnail:ApplicationContext.assetUrlPrefix + "/assets/home/recent/7seg-13.png",
            },
            {
                cardType:"package",
                id:"26656",
                onEdit:this.onEdit,
                name:"EDG-05" ,
                user_name:"EAGLE",
                description:"EDG-05",
                avatar:ApplicationContext.assetUrlPrefix + "/assets/icons/eagle-avatar.png",
                thumb_URL:ApplicationContext.assetUrlPrefix + "/assets/home/recent/edg-05.png",
                thumbnail:ApplicationContext.assetUrlPrefix + "/assets/home/recent/edg-05.png",
            }
        ];
    }

    render() {
        return (
            <DisplayAssets
                {...this.props}
                tabs={this.getDefaultAssetsConfig()}
            />
        );
    }

}


module.exports = DisplayAssetsHome;
